import { Table, Tooltip } from "antd";
import { useContext, useEffect, useState } from "react";


import { ExportToExcel } from "../../utils/exportExcel";

import CreateRequest from "./components/CreateRequest";
import UploadFile from "./components/UploadFile";
import { useQuery } from "@tanstack/react-query";
import Something from "../../components/shared/Something";
import { handleExportRequests, handleFetchRequests } from "../../api/requests";
import Moment from "react-moment";
import { Link } from "react-router-dom";
import { AuthContext } from "../../contexts/AuthContext";
import { DeleteOutlined, EditOutlined, EyeFilled, FileExcelOutlined, ReloadOutlined } from "@ant-design/icons";
import ApproveRequest from "./components/ApproveRequest";
import UpdateApprover from "./components/UpdateApprover";
import DeleteRequest from "./components/DeleteRequest";

export default function Requests({ status }: any) {
  const { user } = useContext(AuthContext);
  const [selected, setSelected] = useState<any>({});
  const [createModal, setCreateModal] = useState<boolean>(false);
  const [signModal, setSignModal] = useState<boolean>(false);
  const [isExporting, setExporting] = useState<boolean>(false);
  const [approveModal, setApproveModal] = useState<boolean>(false);
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [approverModal, setApproverModal] = useState<boolean>(false);
  const access = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
  const adminAccess = [9];

  const [pagination, setPagination] = useState<any>({
    page: 1,
    limit: 10,
    total: 0,
  });

  const {
    data: requests,
    refetch,
    isLoading,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["requests", pagination.page, pagination.limit, status],
    queryFn: () =>
      handleFetchRequests({
        page: pagination.page,
        limit: pagination.limit,
        status: status || "",
      }),
  });

  const handlePageChange = (e: any) => {
    setPagination((prev: any) => ({
      ...prev,
      page: e.current,
      limit: e.pageSize,
    }));
  };
  const handleRefetch = () => {
    refetch();
  };

  const columns: any = [
    {
      title: "S/N",
      width: 40,
      render: (record: any, text: any, index: any) => (
        <span className="text-gray-700 ml-2">
          {pagination?.page * pagination?.limit - pagination?.limit + index + 1}
        </span>
      ),
    },
    {
      title: "PROJECT",
      width: 260,
      render: (record: any) => {
        return (
          <div className="text-gray-700">
            <div className="">{record?.projectName || "-"}</div>
          </div>
        );
      },
    },
    {
      title: "REQUESTED BY",
      width: 110,
      render: (record: any) => (
        <span className="text-gray-700">{record?.requestedBy?.name || "-"}</span>
      ),
    },
    {
      title: "REQUESTED AT",
      width: 110,
      render: (record: any) => (
        <span className="text-gray-700">
          <Moment fromNow>{record?.createdAt}</Moment>
        </span>
      ),
    },

    {
      title: "APPROVER",
      width: 210,
      render: (record: any) => (
        <div className="flex items-center gap-2">
          <button
            onClick={() => {
              setSelected(record);
              setApproverModal(true);
            }}
            className="text-black"
          >
            {record?.approvedBy?.name || (
              <div className="">
                {adminAccess.includes(user?.accessLevel) && (
                  <button className="border px-2 py-1 bg-gray-100 shadow-sm">
                    + Assign
                  </button>
                )}
              </div>
            )}
          </button>
          <span
            className={`${record?.approvalStatus === "Approved"
              ? "text-green-600"
              : "text-red-600"
              }`}
          >
            ({record?.approvalStatus})
          </span>
        </div>

      ),
    },
    {
      title: "APPROVED AT",
      width: 110,
      render: (record: any) => (
        record?.dateApproved ? (

          <span className="text-gray-700">
            <Moment fromNow>{record?.dateApproved}</Moment>
          </span>
        ) : (
          <span className="text-gray-700">-</span>
        )
      ),
    },
    {
      title: "STATUS",
      width: 120,
      render: (record: any) => (
        <span
          className={`${record?.approvalStatus === "Approved"
            ? "text-green-600"
            : "text-red-600"
            }`}
        >
          {record?.status || "-"}
        </span>
      ),
    },


    {
      title: "ACTIONS",
      width: 180,
      align: "center",
      fixed: "right",
      render: (record: any) => (
        <div className="flex justify-end gap-1">
          {record?.approvalStatus === "Pending" &&
            (record?.requestedBy?._id === user?._id || adminAccess.includes(user?.accessLevel)) && (
              <Link
                to={`/change/requests/${record?._id}/edit`}
                className="border px-2 py-1 bg-yellow-50 text-yellow-800 shadow-sm flex items-center"
              >
                <EditOutlined /> <span className="ml-1">Edit</span>
              </Link>
            )}

          {record?.approvalStatus === "Pending" &&
            record?.approvedBy?.email === user?.email && (
              <button
                onClick={() => {
                  setSelected(record);
                  setApproveModal(true);
                }}
                className="border px-2 py-1 bg-gray-100 shadow-sm"
              >
                Approve
              </button>
            )}

          {adminAccess?.includes(user?.accessLevel) && (
            <div className="flex items-center gap-x-2">
              {/* <button
                onClick={() => {
                  setSelected(record);
                  setUnitModal(true);
                }}
                className={`border py-1 px-2 mx-1 flex items-center bg-blue-50 text-blue-800 shadow-sm ${record?.businessUnit ? "bg-green-50 text-green-800" : ""
                  }`}
              >
                <Users size={15} />
                <span className="mx-1">B.U</span>
              </button> */}

              <button
                onClick={() => {
                  if (adminAccess.includes(user?.accessLevel)) {
                    setSelected(record);
                    setDeleteModal(true);
                  }
                }}
                className="border py-1 px-2 mx-1 flex items-center bg-red-50 text-red-800 shadow-sm"
              >
                <DeleteOutlined />
              </button>
            </div>
          )}
        </div>
      ),
    },
    {
      title: "DETAILS",
      width: 80,
      align: "center",
      fixed: "right",
      render: (record: any) => (
        <div className="flex justify-end">
          <Link
            to={`/change/requests/${record?._id}/details`}
            className="border py-1 px-2 mx-1 flex items-center bg-blue-50 text-blue-800 shadow-sm"
          >
            <EyeFilled /> <span className="mx-1">Details</span>
          </Link>
        </div>
      ),
    },
  ];

  const exportRequests = async () => {
    setExporting(true);
    const requests = await handleExportRequests();
    await ExportToExcel(
      requests?.map((item: any, index: number) => {
        return {
          "S/N": index + 1,
          "Change No": item?.changeNo || "-",
          "Project Name": item?.projectName || "-",
          "Project Link": item?.projectLink || "-",
          Priority: item?.priority || "-",
          "Requested By": item?.requestedBy || "-",
          "Requested At": (
            <Moment format="DD/MM/YYYY">{item?.createdAt}</Moment>
          ),
          Status: item?.status || "-",
          Decision: item?.decision || "-",
          Stakeholders: item?.stakeholders || "-",
          Cost: item?.cost || "-",
          Scope: item?.scope || "-",
          Resources: item?.resources || "-",
          Timeline: item?.timeline || "-",
          Year: item?.year || "-",
        };
      }),
      "Requests.xlsx"
    );
    setExporting(false);
  };

  useEffect(() => {
    setPagination({ ...pagination, total: requests?.total });
  }, [requests]);

  return (
    <div className="bg-gray-100">
      <div className="bg-white m-1">
        <div className="flex flex-col sm:flex-row justify-between border p-2">
          <div className="">
            <div className="font-bold capitalize text-lg">
              Change Request Forms
            </div>
            <div className="text-gray-600">Manage all request approvals</div>
          </div>

          <div className="flex">
            <Tooltip title="Export To Excel">
              <button
                className="flex mx-2 justify-center items-center border px-4 h-8  hover:bg-gray-100"
                onClick={() => exportRequests()}
              >
                {isExporting ? <ReloadOutlined /> : <FileExcelOutlined size={20} />}
              </button>
            </Tooltip>
            {access?.includes(user?.accessLevel) && (
              <Link
                to="/change/requests/new"
                className="flex mx-2 justify-center items-center border px-4 h-8 bg-karimjee  hover:bg-karimjee-dark text-white"
              >
                + New
              </Link>
            )}
          </div>
        </div>
        {isError ? (
          <Something refetch={refetch} isFetching={isFetching} />
        ) : (
          <div className="border">
            <Table
              size="small"
              dataSource={requests?.records}
              columns={columns}
              scroll={{ y: 660, x: 0 }}
              rowKey="id"
              bordered
              pagination={{
                current: pagination?.page,
                pageSize: pagination?.limit,
                total: pagination?.total,
              }}
              rowClassName={"hover:bg-gray-100 cursor-pointer"}
              onChange={(e: any) => handlePageChange(e)}
              loading={isLoading}
            />
          </div>
        )}
      </div>


      {createModal && (
        <CreateRequest
          isVisible={createModal}
          setVisible={setCreateModal}
          refetch={handleRefetch}
        />
      )}

      {signModal && (

        <UploadFile
          isVisible={signModal}
          setVisible={setSignModal}
          selected={selected}
          refetch={refetch}
        />
      )}
      {approveModal && (
        <ApproveRequest
          isVisible={approveModal}
          setVisible={setApproveModal}
          selected={selected}
          refetch={handleRefetch}
        />
      )}


      {approverModal && (
        <UpdateApprover
          isVisible={approverModal}
          setVisible={setApproverModal}
          selected={selected || {}}
          refetch={handleRefetch}
        />
      )}

      {deleteModal && (
        <DeleteRequest
          isVisible={deleteModal}
          setVisible={setDeleteModal}
          selected={selected || {}}
          refetch={handleRefetch}
        />
      )}
    </div>
  );
}
